import { createHashRouter } from 'react-router-dom';
import { lazy } from 'react';

// project-imports
import ChartMapRoutes from './ChartMapRoutes';
import ComponentsRoutes from './ComponentsRoutes';
import FormsRoutes from './FormsRoutes';
import OtherRoutes from './OtherRoutes';
import PagesRoutes from './PagesRoutes';
import NavigationRoutes from './NavigationRoutes';
import Loadable from 'components/Loadable';
// import DashboardLayout from 'layout/Dashboard';

// render - 404 page
const NotFound = Loadable(lazy(() => import('views/NotFound')));

// ==============================|| ROUTING RENDER ||============================== //

const router = createHashRouter(
  [
    NavigationRoutes,
    ComponentsRoutes,
    FormsRoutes,
    PagesRoutes,
    OtherRoutes,
    ChartMapRoutes,
    {
      path: '*',
      element: (
        // <DashboardLayout>
        <NotFound></NotFound>
        // </DashboardLayout>
      )
    }
  ],
  {
    basename: import.meta.env.VITE_APP_BASE_NAME
  }
);

export default router;
